import { render, staticRenderFns } from "./practice-content.vue?vue&type=template&id=66346947&scoped=true"
import script from "./practice-content.vue?vue&type=script&lang=js"
export * from "./practice-content.vue?vue&type=script&lang=js"
import style0 from "./practice-content.vue?vue&type=style&index=0&id=66346947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66346947",
  null
  
)

export default component.exports